// Grava um grito pelo microfone, com tempo máximo. Chrome e Android gravam WebM, Safari grava MP4.
export const DURACAO_GRITO = 2000;

export function podeGravar(): boolean {
  return typeof MediaRecorder !== 'undefined' && !!navigator.mediaDevices?.getUserMedia;
}

export async function gravar(ms = DURACAO_GRITO): Promise<Blob> {
  let stream: MediaStream;
  try {
    stream = await navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: true, noiseSuppression: true } });
  } catch {
    throw new Error('Sem acesso ao microfone. Libere o microfone para este site nas configurações do navegador.');
  }
  const tipo = ['audio/webm;codecs=opus', 'audio/mp4', 'audio/ogg;codecs=opus', 'audio/webm']
    .find((t) => MediaRecorder.isTypeSupported?.(t));
  const rec = new MediaRecorder(stream, tipo ? { mimeType: tipo, audioBitsPerSecond: 64_000 } : undefined);
  const partes: Blob[] = [];
  rec.ondataavailable = (e) => { if (e.data.size) partes.push(e.data); };
  return new Promise((ok, falha) => {
    const parar = () => { for (const t of stream.getTracks()) t.stop(); };
    rec.onstop = () => {
      parar();
      const blob = new Blob(partes, { type: (rec.mimeType || tipo || 'audio/webm').split(';')[0] });
      if (!blob.size) falha(new Error('A gravação saiu vazia. Tente de novo.'));
      else if (blob.size > 200 * 1024) falha(new Error('A gravação ficou grande demais.'));
      else ok(blob);
    };
    rec.onerror = () => { parar(); falha(new Error('Não deu para gravar. Tente de novo.')); };
    rec.start();
    setTimeout(() => { if (rec.state !== 'inactive') rec.stop(); }, ms);
  });
}
